<template>
    <div :class="['card', {'card_slider': isSlider}, 'card_complex']">
        <div class="card__top">
            <div class="card__new" v-if="complex.is_promotional">
                new
            </div>
            <favorite-button :id="complex.id" :is-catalog="true" :is-complex="true"></favorite-button>
        </div>
        <a :href="this.$root.baseUrl + '/complexes/' + complex.slug" class="card__img">
            <div class="card__slider swiper">
                <div class="card__wrapper swiper-wrapper" v-if="areImagesArray(complex.images)">
                    <div class="card__slide swiper-slide"
                         v-for="(image, index) in complex.images.slice(0, 5)"
                         :key="index"
                    >
                        <picture>
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(min-width: 960px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="detailsThumb(image) + ' 1x, ' + detailsFull(image) + ' 2x'"
                                media="(min-width: 846px) and (max-width: 959px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(min-width: 641px) and (max-width: 845px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="detailsThumb(image) + ' 1x, ' + detailsFull(image) + ' 2x'"
                                media="(min-width: 426px) and (max-width: 640px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(max-width: 425px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <img
                                :data-src="listThumb(image)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'"
                                :alt="image['custom_properties']['alt']">
                        </picture>
                    </div>
                </div>
                <div v-else class="card__wrapper swiper-wrapper">
                    <div class="card__slide swiper-slide">
                        <img src="/img/noimage/no-image.svg" alt="">
                    </div>
                </div>
                <div class="card-button card-button_prev _icon-slider_arr-left"></div>
                <div class="card-button card-button_next _icon-slider_arr-right"></div>
                <div class="swiper-pagination swiper-pagination_card"></div>
            </div>
        </a>
        <div class="card__info info-card">
            <div class="info-card__top top-card-info">
                <div class="top-card-info__loc" v-if="complex.district">
                    {{ complex.district.title }}
                </div>
                <a :href="this.$root.baseUrl +'/complexes/' + complex.slug" class="top-card-info__title">
                    {{ complex.title }}
                </a>
                <div class="top-card-info__subtitle">
                    <p v-html="complex.cleanedUpOverview"></p>
                </div>
            </div>
            <div class="top-card-info__price">
                <span v-if="complex.price_from">{{ 'from' | trans }} {{ formatPrice(complex.price_from) }} {{ trans('currencies.'+currency) }}</span>
                <span v-if="complex.price_to">{{ 'up to' | trans }} {{ formatPrice(complex.price_to) }} {{ trans('currencies.'+currency) }}</span>
                <span class="info__price__on-request"
                      v-if="!complex.price_from && !complex.price_to"
                >
                    {{ 'Price upon request' | trans }}
                </span>
            </div>
            <div class="info-card__bottom bottom-card-info">
                <template v-if="complex.builder">
                    <div class="bottom-card-info__label">{{ 'Builder' | trans }}:</div>
                    <span>{{ complex.builder.title }} </span>
                </template>
                <div class="bottom-card-info__actions">
                    <a :href="`https://wa.me/${messengerPhone}?text=${transParam(trans('whatsapp.complex_message'),{ 'url': encodeURIComponent(complexUrl)})}`" class="bottom-card-info__link" target="_blank" rel="nofollow noopener noreferrer">
                        <img src="/img/whatsapp.svg" alt="">
                        Whatsapp
                    </a>
                    <a :href="'tel:'+contactPhone" class="bottom-card-info__link" rel="nofollow noopener noreferrer">
                        <img src="/img/tel.svg" alt="">
                        Call
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {addLoadListenerToLazyLoadObjects, initSliders} from "../../shareable/functions"
import transParam from "../../../helpers/trans";

export default {
    name: "CatalogComplexCard",
    data(){
        return {
            transParam: transParam
        }
    },
    props: {
        complex: {
            type: Object,
            default: null
        },
        isSlider: {
            type: Boolean,
            default: false,
        }
    },
    computed:{
        complexUrl() {
            return (this.$root.baseUrl || '') + '/complexes/' + this.complex.slug;
        },
        currency() {
            return window.currentCurrency;
        },
        messengerPhone() {
            return window.messengerPhone;
        },
        contactPhone() {
            return window.contactPhone;
        },
    },
    methods: {
        formatPrice(price) {
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        areImagesArray(images) {
            return Array.isArray(images) && images.length > 0
        },
        listThumb(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-list_thumb_webp.webp';
        },
        detailsThumb(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-details_thumb_webp.webp';
        },
        detailsFull(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-details_full_webp.webp';
        }
    },
    mounted() {
        initSliders();
        addLoadListenerToLazyLoadObjects();
    }
}

</script>

<style scoped>
.card {
    //height: 620px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}


.card.card_slider {
    height: auto !important;
}

.card.card_slider img {
    height: 100% !important;
}
</style>
